import Slider from "react-slick";
import React from "react";
import CountUp from "react-countup";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Quota() {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="quote-area">
      <div className="container-fluid">
        <div className="row justify-content-center align-items-center" data-cues="slideInUp">
          <div className="col-lg-7 col-md-12">
            <div className="quote-slider-wrapper">
              <Slider {...settings}>
                {[
                  {
                    text: "We build homes that turn dreams into reality, providing lasting happiness and comfort.",
                    image: "/img/user1.png",
                    name: "Mr. MOHAN Kumawat",
                    title: "Property Manager & Accountant",
                  },
                  {
                    text: "Crafting Dreams – Designing Homes That Inspire",
                    image: "/img/user2.png",
                    name: "Miss. Monika Shamram",
                    title: "Senior Manager",
                  },
                  {
                    text: "We bring your vision to life, crafting spaces that inspire and stand the test of time.",
                    image: "/img/user3.png",
                    name: "ADVOCATE UMMED SINGH",
                    title: "CEO",
                  },
                ].map((quote, idx) => (
                  <div key={idx} className="quote-slide">
                    <div className="quote-content">
                      <img src="/img/quote.svg" className="quote" alt="quote" />
                      <h3>{quote.text}</h3>
                      <div className="info">
                        <div className="image">
                          <img src={quote.image} alt="user" />
                        </div>
                        <div className="title">
                          <p>{quote.name}</p>
                          <span>{quote.title}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
          <div className="col-lg-5 col-md-12">
            <div className="quote-fun-facts-box">
              <div className="row justify-content-center g-0">
                {[
                  { end: 50, text: "K", label: "Our Happy Customers" },
                  { end: 98, text: "%", label: "Clients Satisfaction Rate" },
                  { end: 50, text: "L Sqft+", label: "Area Developed" },
                  { end: 85, text: "+", label: "Real Estate Agents" },
                ].map((item, i) => (
                  <div key={i} className="col-lg-6 col-sm-6">
                    <div className="box">
                      <div className="d-flex align-items-center">
                        <h3 className="counter"><CountUp end={item.end} duration={5} /></h3>
                        <h3 className="text">{item.text}</h3>
                      </div>
                      <p>{item.label}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Quota;
